import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subcategoria-producto',
  templateUrl: './subcategoria-producto.component.html',
  styleUrls: ['./subcategoria-producto.component.scss']
})
export class SubcategoriaProductoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/subcategoria-producto/subcategoria-producto.component.ts